"use client";

import { useLinkAccount, useLogin, usePrivy } from "@privy-io/react-auth";
import { cn } from "logic/utils";
import { useState } from "react";
import { ButtonDS } from "ui/components/ButtonDS";

import { REGULAR } from "./constants";

/** Signs in with a wallet, or links one when already signed in by email. */
export function WalletLogin() {
  const { authenticated, ready, user } = usePrivy();
  const { linkWallet } = useLinkAccount();
  const { login } = useLogin();

  const handleConnect = () => {
    if (authenticated) {
      linkWallet();
    } else {
      login({ loginMethods: ["wallet"] });
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <ButtonDS className={cn("w-full sm:w-[296px]", REGULAR)} disabled={!ready} onClick={handleConnect} size="md">
        Connect Wallet to Login
      </ButtonDS>

      {user?.email ? <SignedInAs email={user.email.address} /> : null}
    </div>
  );
}

/** Signed in by email with no wallet yet: the page has no shell (and so no
 *  account menu), so this is the way back out. */
function SignedInAs(props: { email: string }) {
  const { email } = props;
  const { logout } = usePrivy();
  const [signingOut, setSigningOut] = useState(false);

  const signOut = async () => {
    setSigningOut(true);
    await logout().finally(() => setSigningOut(false));
  };

  return (
    <p className="text-body-md-400 text-surface-on-surface-variant">
      Signed in as <span className="text-surface-on-surface">{email}</span>.{" "}
      <button
        className="cursor-pointer underline underline-offset-4 hover:text-surface-on-surface disabled:cursor-default disabled:opacity-50"
        disabled={signingOut}
        onClick={signOut}
        type="button"
      >
        Sign out
      </button>
    </p>
  );
}
